import { motion } from "framer-motion";
import { Icon3D } from "@/components/landing/Icon3D";
import { fadeUp, cardRevealDeep } from "@/lib/animations";
import { Section, Overline, H2 } from "./JobPrimitives";
import { highlightCards } from "./jobData";

export const JobAbout = () => (
  <Section id="sobre" className="py-16 md:py-24" testid="section-sobre">
    <motion.div {...fadeUp} className="max-w-3xl">
      <Overline>Sobre a oportunidade</Overline>
      <H2 highlight="Entrevista Médica Qualificada">
        Enfermeiro(a) Administrativo —
      </H2>
      <p className="mt-6 text-lg text-[#64748B] leading-relaxed">
        A Previsa Saúde busca profissionais de Enfermagem com excelente
        comunicação, capacidade analítica e interesse em atuar na área
        administrativa e de auditoria em saúde.
      </p>
      <p className="mt-4 text-lg text-[#64748B] leading-relaxed">
        O(a) profissional será responsável pela realização de{" "}
        <strong className="text-[#1F2937]">
          Entrevistas Médicas Qualificadas
        </strong>
        , contribuindo para a análise criteriosa das informações de saúde de
        beneficiários e proponentes, com precisão técnica, clareza e
        responsabilidade.
      </p>
    </motion.div>

    <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {highlightCards.map((h, idx) => (
        <motion.article
          key={h.title}
          {...cardRevealDeep(idx * 0.06)}
          data-testid={`highlight-card-${idx}`}
          className="group bg-white rounded-3xl border border-[#E5EAF2] p-7 hover:shadow-[0_20px_50px_rgba(53,50,179,0.10)] hover:border-[#3787F5]/30 transition-all duration-300 hover:-translate-y-1"
        >
          <Icon3D
            icon={h.icon}
            variant={h.variant}
            size="lg"
            className="mb-5 group-hover:scale-110 group-hover:-rotate-3"
          />
          <h3 className="text-lg font-bold text-[#1F2937]">{h.title}</h3>
          <p className="mt-3 text-[15px] text-[#64748B] leading-relaxed">
            {h.desc}
          </p>
        </motion.article>
      ))}
    </div>
  </Section>
);
